<template>
  <div class="login-body">
    <div class="login">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th colspan="2" class="text-center" style="min-width:5rem;">
                用戶資料
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in infos" :key="item.field">
              <td>{{ item.fieldText }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="d-flex justify-end" style="margin-top:10px;">
        <v-btn color="secondary" @click="btnLogout">Logout</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars  */
import homeDrawer from '@/lib/drawer/homeDrawer'
import axios from '@/lib/axios'
import qs from 'qs'

export default {
  computed: {
    infos(){
      let keys = ['name', 'email', 'avatar_url', 'introduction', 'persional_page']
      let texts = ['姓名', '信箱', '頭像連結', '介紹', '個人網頁']
      return keys.map((key, i)=>{
        return {
          field: key,
          value: this[key],
          fieldText: texts[i]
        }
      })
    }
  },
  data(){
    return {
      id: '',
      name: '',
      email: '',
      avatar_url: '',
      introduction: '',
      persional_page: ''
    }
  },
  mounted(){
    this.$store.commit('appbar/setupDrawer', {
      items: homeDrawer,
      autoDisplay: true,
      show: !this.$mobile
    })
    // this.$store.commit('user/sync')
    let user
    if(this.$store.state.user.profile){
      user = this.$store.state.user.profile
      this.name = user.name
      this.email = user.email
      this.avatar_url = user.avatar_url
      this.introduction = user.introduction
      this.persional_page = user.persional_page
    }
  },
  beforeDestroy(){
    this.$store.commit('appbar/clearDraer')
  },
  methods: {
    async btnLogout() {
      var result = axios.get(process.env.VUE_APP_API_ENDPOINT + '/wordprison/logout').then(res=>{
        if(res.status === 200){
          if(res.data.code === 200){
            this.$store.commit('user/clear')
            this.$router.push('/')
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.btn-columns .v-btn{
  margin-bottom: 0.8rem;
}
.login-body {
  padding-top: 100px;
  width: 100%;
  height: 100%;
}
.login {
  margin: 0 auto;
  padding: 2rem;
  max-width: 500px;
}
.login-title {
  text-align: center;
  margin-top: 20px;
}
</style>
